require("angular");
require("ng-tags-input");
require("angular-route");
require("angular-aria");
require("angular-sanitize");
require("angular-resource");
require("angular-animate");
require("angular-cookies");
require("angular-content-editable");
window.moment = require("moment");
require("angular-moment");
require("moment/min/locales");
require("angular-xeditable");
require("angular-translate");
require("angular-translate-loader-static-files");
require("ng-dialog");
require("angular-ui-bootstrap");
window.ZeroClipboard  = require("zeroclipboard");
require("ng-clip");
require("ui-select");
require("ng-file-upload");
require("angular-legacy-sortablejs-maintained");
require("ng-toast");
require("angular-wizard");
require("ui-cropper");
require("ng-tags-input");
require("angulartics");
require("angulartics-google-analytics");
require("angular-css-injector");
//window.paypal = require("paypal-checkout");
window.THREE = require('three');
const OrbitControls = require('three-orbitcontrols');
require("highcharts-ng");
require('intersection-observer');
PDFJSAnnotate = require('pdf-annotate');
require("angular-dynamic-locale-secure");
require("oclazyload");


